export default __webpack_public_path__ + "static/1751-e02988eb7753ffbfb45f08ee29cb88fb.gif";